import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { sentryError } from 'utils';

export default function useCallbackAsync<T = void>(
  callback: (...args: any[]) => Promise<T>,
  shouldThrowError = true,
) {
  const [loading, setLoading] = useState<boolean>();
  const { popServerError } = useContext(PopNotificationsContext);

  const callbackRef = useRef<(...args: any[]) => Promise<T>>(callback);

  const asyncCallback = useCallback(
    async (...args: any[]) => {
      try {
        setLoading(true);

        return await callbackRef.current(...args);
      } catch (e) {
        sentryError(e);

        if (shouldThrowError) popServerError(e);
      } finally {
        setLoading(false);
      }
    },
    [shouldThrowError, popServerError],
  );

  useEffect(() => {
    callbackRef.current = callback;
  });

  return [asyncCallback, loading] as [(...args: any[]) => Promise<T>, boolean];
}
